module.exports = __webpack_public_path__ + "static/media/2.4bb9a410.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/2.png
// module id = 1350
// module chunks = 0